import { createContext, useContext } from 'react';

import { ITranslationData } from '../../store/translations';

export const TranslationsContext = createContext<ITranslationData>({});

export const useTranslationsContext = () => useContext(TranslationsContext);
